import { render, staticRenderFns } from "./PreregistrationUpdate.vue?vue&type=template&id=73469104&scoped=true"
import script from "./PreregistrationUpdate.vue?vue&type=script&lang=js"
export * from "./PreregistrationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73469104",
  null
  
)

export default component.exports